import styled from "styled-components";

const NameContainer = styled.div`
  display: flex;
  align-items: center;
`;

const NameWrapperInner = styled.div`
  display: flex;
  align-items: center;
`;

const AfterNameIcon = styled.div`
  margin: auto auto auto ${props => props.theme.spacing.S_10};
`;

const Name = styled.div<{ $label_state: boolean }>`
  color: inherit;
  display: flex;
  ${props => props.theme.belowBreakpoint} {
    flex-direction: column;
    color: ${props => (props.$label_state ? props.theme.colors.tomato : props.theme.colors.primary.base)};
  }
`;

const Closed = styled.div`
  margin-left: ${props => props.theme.spacing.S_10};
  color: ${props => props.theme.colors.tomato};
  font-weight: ${props => props.theme.fontWeight.regular};
  ${props => props.theme.belowBreakpoint} {
    display: none;
    margin-left: 0;
  }
`;

const LabelContainer = styled.div`
  color: inherit;
`;

export { NameContainer, NameWrapperInner, Name, Closed, LabelContainer, AfterNameIcon };
